
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[league]/matchup-output/[teamName]/[opponentName]/[site]",
      function () {
        return require("private-next-pages/[league]/matchup-output/[teamName]/[opponentName]/[site]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[league]/matchup-output/[teamName]/[opponentName]/[site]"])
      });
    }
  